export default [{
        path: '/feedbackReportQuestion',
        name: 'feedbackReportQuestion',
        component: () =>
            import ('@/components/page/storeFeedback/reportQuestionList.vue'),
        meta: { title: '疑问沟通' } //
    },
    {
        path: '/feedbackReportQuestion-detail',
        name: 'feedbackReportQuestionDetail',
        component: () =>
            import ('@/components/page/storeFeedback/reportQuestionDetail.vue'),
        meta: { title: '疑问沟通' } //
    },
]